import { GetProductFeaturesForNonPdpPageParams, getProductFeaturesForNonPdpPage } from './get-product-features-for-non-pdp-page';
import { emitTrackingEvent } from './emit-tracking-event';

export type AddNonPdpFeaturesToPageImpressionParams = GetProductFeaturesForNonPdpPageParams;
export const addNonPdpFeaturesToPageImpression = ({ variationId }: AddNonPdpFeaturesToPageImpressionParams) => {
    emitTrackingEvent(
        'tracking.bct.addFeaturesToPageImpression',
        getProductFeaturesForNonPdpPage({
            variationId,
        })
    );
};
